import { Progress } from 'antd';
import { ProgressProps } from 'antd/lib/progress/progress';
import * as React from 'react';

const Component: React.StatelessComponent<ProgressProps> = props => <Progress {...props} />;

export default Component;
